import { SET_LOADING_PROGRESS } from "./action-types";

export const setLoadingProgress = (progress:number) => ({
  type: SET_LOADING_PROGRESS,
  payload: progress,
});